export default __webpack_public_path__ + "static/flag-capture-dark-6e9de77aaa99bb6a8d2c65fa91961a93.png";